import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
function ConfirmationModal({ callBack, open, setOpen, text, headerText, confirmButtonText }) {
  // Handle modal close
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal data-cy="confirmationModal" open={open} onClose={handleClose}>
      <Card
        sx={{
          p: '30px',
          width: '20vw',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: '9999',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography align="left" variant="h4" onClick={handleClose}>
          {' '}
          {/* Make headerText clickable to close */}
          {headerText}
        </Typography>
        <Typography align="left">{text}</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '1vw',
            marginTop: '3vh',
          }}
        >
          <Button
            data-cy="button-cancel-confirmationModal"
            variant="contained"
            sx={{ width: '6vw', height: '5vh' }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            sx={{ backgroundColor: 'red', width: '6vw', height: '5vh', color: 'white' }}
            onClick={() => {
              handleClose();
              callBack();
            }}
            variant="primary"
          >
            {confirmButtonText}
          </Button>
        </Box>
      </Card>
    </Modal>
  );
}

export default ConfirmationModal;
